import { useTranslation } from '@shared/core';

/** Returns the translated lock message when a payout currency is locked, or null otherwise. */
export const useCurrencyLockMessage = (lockedCurrencyCode: string | null): string | null => {
  const { tq } = useTranslation('yourRegistry');
  if (!lockedCurrencyCode) return null;
  return tq`Your currency is set to ${lockedCurrencyCode} because a Stripe account is connected to your event. To change currencies, the existing Stripe account must be disconnected first.`;
};
